import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { Portal } from 'bringg-web/components';
import { useStores } from 'bringg-web/recipes';

import './alert-bell-portal.scss';

const AlertsBell = observer(() => {
	const {
		alertsStore: { isAllAlertsLoaded, fetchAlerts, visibleAlertsTotalCount }
	} = useStores();

	useEffect(() => {
		if (!isAllAlertsLoaded) {
			fetchAlerts({ limit: 5000 });
		}
	}, [isAllAlertsLoaded, fetchAlerts]);

	return visibleAlertsTotalCount ? (
		<div className="alerts-counter">
			<span className="badge header-alerts-badge">{visibleAlertsTotalCount}</span>
		</div>
	) : null;
});

const AlertBellPortal = () => {
	return <Portal element={<AlertsBell />} nodeId="alert-bell-portal" />;
};

export default AlertBellPortal;

// exported for testing only
export { AlertsBell };
